export default __webpack_public_path__ + "static/brass-texture-aaae2fd470881271283c19b3ca2779e2.png";